import { render, staticRenderFns } from "./RecentChats.vue?vue&type=template&id=217ac0b1&scoped=true&"
import script from "./RecentChats.vue?vue&type=script&lang=ts&"
export * from "./RecentChats.vue?vue&type=script&lang=ts&"
import style0 from "./RecentChats.vue?vue&type=style&index=0&id=217ac0b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217ac0b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSimpleTable,VTooltip})
